import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Update `}<a parentName="p" {...{
        "href": "https://posthog.com/docs/integrate/client/js"
      }}>{`posthog-js`}</a>{`2 to version 1.16.0 or above to make use of the new functionality.`}</p>
    <p>{`In  it's possible to declare that a user is currently "active" in a particular group. This means all events (both normal and autocaptured) are considered to be for that group.`}</p>
    <p>{`To make sure all events get attached to groups, we recommend calling `}<inlineCode parentName="p">{`posthog.group`}</inlineCode>{` in `}<inlineCode parentName="p">{`loaded`}</inlineCode>{` callback.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`posthog.init('[your api key]', {
    api_host: 'https://posthog.[your-domain].com',
    loaded: function(posthog) {
        posthog.identify('[user unique id]');

        posthog.group('company', 'id:5', {
            company_name: 'Awesome Inc',
            employees: 11
        });

        // A call without properties sets the group on subsequent events
        // but does not update properties
        posthog.group('playlist', 'id:77');
    }
});
`}</code></pre>
    <p>{`Subsequent calls to `}<inlineCode parentName="p">{`posthog.group()`}</inlineCode>{` with the same group type but a different group key make the new group be active.`}</p>
    <h4 {...{
      "id": "handling-logging-out"
    }}>{`Handling logging out`}</h4>
    <p>{`When the user logs out it's important to call `}<inlineCode parentName="p">{`posthog.reset()`}</inlineCode>{` to avoid new events being registered under registered groups and the logged in user.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      